
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/onesignal",
      function () {
        return require("private-next-pages/destinations/onesignal.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/onesignal"])
      });
    }
  